<script lang="ts">
	import type { MarkdownOptions, Renderers } from '@magidoc/plugin-svelte-marked';
	import type { Tokens, Token } from 'marked';
	import { decodeHtmlEntities } from '../../../../../utils/decodeHtmlEntities/decodeHtmlEntities';

	interface Props {
		dummy?: boolean;
		tokens: Token[];
		options?: MarkdownOptions | undefined;
		renderers?: Renderers | undefined;
		light?: boolean;
	}

	let { tokens, light = false, dummy = false }: Props = $props();

	const getStrongToken = (_token: Token) => {
		return _token as Tokens.Strong;
	};

	const getTextToken = (_token: Token) => {
		return _token as Tokens.Paragraph;
	};

	const getLinkToken = (_token: Token) => {
		return _token as Tokens.Link;
	};

	const getEmToken = (_token: Token) => {
		return _token as Tokens.Em;
	};
</script>

{#each tokens as _token}
	{#if _token.type === 'strong'}
		<span style="font-weight: 700">
			{getStrongToken(_token).text}
		</span>
	{:else if _token.type === 'text'}
		{decodeHtmlEntities(getTextToken(_token).text)}
	{:else if _token.type === 'link'}
		{#if dummy}
			<span
				style={`font-weight: 700; text-decoration: underline; color: ${light ? 'white' : '#C6412E'}`}
			>
				{getLinkToken(_token).text}
			</span>
		{:else}
			<a href={getLinkToken(_token).href} rel="noopener noreferrer" target="_blank">
				<span
					style={`font-weight: 700; text-decoration: underline; color: ${light ? 'white' : '#C6412E'}`}
				>
					{getLinkToken(_token).text}
				</span>
			</a>
		{/if}
	{:else if _token.type === 'em'}
		<span style="font-style: italic">
			{getEmToken(_token).text}
		</span>
	{:else if _token.type === 'html' && _token.raw === '<br>'}
		<br />
	{/if}
{/each}
